// @ts-nocheck
(() => {
  const INIT_KEY = '__aoneWishlistUiInit';
  if (window[INIT_KEY]) return;
  window[INIT_KEY] = true;

  const STORAGE_KEY = 'aone:wishlist:v1';
  const BUTTON_SELECTOR = '[data-wishlist-toggle]';
  const COUNT_SELECTOR = '[data-wishlist-count]';
  const ACTIVE_CLASS = 'is-active';
  const ADD_LABEL = 'Add to wishlist';
  const REMOVE_LABEL = 'Remove from wishlist';
  const OUTLINE_ICON = '♡';
  const FILLED_ICON = '♥';

  function normalizeId(value) {
    if (value == null) return '';
    let normalized = String(value).trim();
    if (!normalized || normalized.includes('[[')) return '';
    if (normalized.includes('/')) {
      normalized = normalized.split('/').pop() || '';
    }
    return normalized.trim();
  }

  function buildEntryFromButton(button) {
    const productId = normalizeId(button.getAttribute('data-product-id'));
    const variantId = normalizeId(button.getAttribute('data-variant-id'));
    const handle = normalizeId(button.getAttribute('data-product-handle'));
    return { productId, variantId, handle };
  }

  function buildEntryKey(entry) {
    if (entry.productId) return `product:${entry.productId}`;
    if (entry.variantId) return `variant:${entry.variantId}`;
    if (entry.handle) return `handle:${entry.handle}`;
    return '';
  }

  function readWishlist() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function sanitizeWishlist(wishlist) {
    if (!wishlist || typeof wishlist !== 'object') return {};
    const next = {};
    Object.entries(wishlist).forEach(([key, entry]) => {
      if (!key || !entry || typeof entry !== 'object') return;
      const normalizedEntry = {
        productId: normalizeId(entry.productId),
        variantId: normalizeId(entry.variantId),
        handle: normalizeId(entry.handle),
      };
      const normalizedKey = buildEntryKey(normalizedEntry) || key;
      if (!normalizedKey) return;
      next[normalizedKey] = normalizedEntry;
    });
    return next;
  }

  function writeWishlist(wishlist) {
    try {
      const normalized = sanitizeWishlist(wishlist);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
      return true;
    } catch (error) {
      return false;
    }
  }

  function isEntryActive(entry, wishlist) {
    const key = buildEntryKey(entry);
    if (!key) return false;
    return Object.prototype.hasOwnProperty.call(wishlist, key);
  }

  function setButtonVisualState(button, isActive) {
    const icon = button.querySelector('[data-wishlist-icon]');
    button.classList.toggle(ACTIVE_CLASS, isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', isActive ? REMOVE_LABEL : ADD_LABEL);
    if (icon) {
      icon.textContent = isActive ? FILLED_ICON : OUTLINE_ICON;
    }
  }

  function applyStateToAllButtons() {
    const wishlist = readWishlist();
    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      const entry = buildEntryFromButton(button);
      const isActive = isEntryActive(entry, wishlist);
      setButtonVisualState(button, isActive);
    });
  }

  function updateHeaderCount() {
    const wishlist = readWishlist();
    const count = Object.keys(wishlist).length;
    document.querySelectorAll(COUNT_SELECTOR).forEach((node) => {
      node.textContent = String(count);
      node.hidden = count <= 0;
    });
    document.dispatchEvent(
      new CustomEvent('aone:wishlist-updated', {
        detail: {
          count,
          entries: wishlist,
        },
      })
    );
  }

  function toggleWishlistEntry(button) {
    const wishlist = readWishlist();
    const entry = buildEntryFromButton(button);
    const key = buildEntryKey(entry);
    if (!key) return;

    if (Object.prototype.hasOwnProperty.call(wishlist, key)) {
      delete wishlist[key];
    } else {
      wishlist[key] = entry;
    }

    if (!writeWishlist(wishlist)) return;
    applyStateToAllButtons();
    updateHeaderCount();
  }

  function removeWishlistByKey(key) {
    const wishlist = readWishlist();
    if (!Object.prototype.hasOwnProperty.call(wishlist, key)) return;
    delete wishlist[key];
    if (!writeWishlist(wishlist)) return;
    applyStateToAllButtons();
    updateHeaderCount();
  }

  function setWishlistEntries(entries) {
    if (!writeWishlist(entries)) return;
    applyStateToAllButtons();
    updateHeaderCount();
  }

  function clearWishlist() {
    setWishlistEntries({});
  }

  function getWishlistEntries() {
    return readWishlist();
  }

  function handleWishlistClick(event) {
    const clickTarget = event.target instanceof Element ? event.target : null;
    if (!clickTarget) return;

    const button = clickTarget.closest(BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    toggleWishlistEntry(button);
  }

  let observerTimer = null;
  function scheduleStateRefresh() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(() => {
      applyStateToAllButtons();
      updateHeaderCount();
    }, 60);
  }

  function initObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            (node.matches && (node.matches(BUTTON_SELECTOR) || node.matches(COUNT_SELECTOR))) ||
            node.querySelector(BUTTON_SELECTOR) ||
            node.querySelector(COUNT_SELECTOR)
          ) {
            scheduleStateRefresh();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', handleWishlistClick, true);
  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    applyStateToAllButtons();
    updateHeaderCount();
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        applyStateToAllButtons();
        updateHeaderCount();
        initObserver();
      },
      { once: true }
    );
  } else {
    applyStateToAllButtons();
    updateHeaderCount();
    initObserver();
  }

  const existingApi = window.AoneWishlist && typeof window.AoneWishlist === 'object' ? window.AoneWishlist : {};
  window.AoneWishlist = {
    ...existingApi,
    storageKey: STORAGE_KEY,
    getEntries: getWishlistEntries,
    setEntries: setWishlistEntries,
    clear: clearWishlist,
    removeByKey: removeWishlistByKey,
    buildEntryKey,
    updateUi: () => {
      applyStateToAllButtons();
      updateHeaderCount();
    },
  };
})();
